import {
  orderBy, map, findIndex, sortBy,
} from 'lodash';
import api from 'src/api';
import { l, formattedMessage, isEmpty } from 'src/utils';
import { parseAccount } from 'api/getClientCard';
import { UPDATE_ACTIVITIES_BY_CUSTOMER } from 'src/store/modules/activities';
import { isExternalOperator } from 'src/store/modules/user';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';
export const SET_CURRENT_ACTIVITY = 'SET_CURRENT_ACTIVITY';

const data = {
  client: {
    id: '',
    name: '',
    isShowInfo: true,
    activities: [],
    omniCustomer: {
      id: '',
      birthdate: '',
      number: null,
      email: '',
      firstName: '',
      lastName: '',
      middleName: '',
      gender: '',
      vip: false,
      customInfo: [],
    },
  },
  currentActivity: undefined,
  activitiesMessages: [{}],
  activityMessages: [],
  clientCases: [],
  clientOpenedCases: [],
  clientClosedCases: [],
  openedCasesTotal: 0,
  closedCasesTotal: 0,
  showClientCases: false,
  showClientCard: false,
  totalActivitiesCount: 0,
  firstActivityDate: undefined,
  firstClosedCasesActivityDate: undefined,
  fetching: false,
  team: {},
};

/**
 * @param {Array} clientCases
 * @param {Function} filterCondition
 * @return {Array}
 */

function formattedMessages(msgs, customerType, currentID) {
  return map(msgs, (msg) => formattedMessage(msg, customerType, currentID));
}

const actions = {
  async getClientCard({ commit, rootState, rootGetters }, clientId) {
    try {
      if (clientId) {
        const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
        const userRole = rootState.user.role;
        const client = await api.getClientCard(clientId, userRole, isExternalOperatorVal);
        commit('SET_CLIENT', client);
      }
    } catch (error) {
      l.error(error);
    }
  },
  async loadCustomerCases({ commit, rootGetters }, clientId) {
    if (clientId) {
      const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
      const customerCases = await api.getCustomerCases(clientId, isExternalOperatorVal);
      commit('SET_CLIENT_CASES', customerCases);
    }
  },
  async loadCustomerCasesPagination({ commit }, {
    customerId, page, pageSize, opened, moreData = false,
  }) {
    commit('SET_FETCHING');
    return api.getCustomerCasesPagination({
      customerId,
      page,
      pageSize,
      opened,
    })
      .then((res) => {
        if (opened) {
          commit('SET_CLIENT_OPENED_CASES', {
            clientOpenedCases: res.customerCases,
            total: res.totalCount,
            totalActivitiesCount: res.totalActivitiesCount,
            moreData,
            firstActivityDate: res.firstActivityDate,
          });
          return res;
        } commit('SET_CLIENT_CLOSED_CASES', {
          clientClosedCases: res.customerCases,
          total: res.totalCount,
          totalActivitiesCount: res.totalActivitiesCount,
          moreData,
          firstActivityDate: res.firstActivityDate,
        });
        return res;
      }).catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  async updateCustomer({ commit, rootGetters }, clientData) {
    const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
    const omniCustomer = await api.updateOmniCustomer(clientData, isExternalOperatorVal);
    commit('SET_OMNI_CUSTOMER', omniCustomer);
    commit(`activities/${UPDATE_ACTIVITIES_BY_CUSTOMER}`, omniCustomer, { root: true });
    return omniCustomer;
  },
  async loadActivityMessages({ commit, rootGetters }, { activityId }) {
    const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
    let messages = await api.getActivityClientCard(activityId, isExternalOperatorVal);
    const currentID = Number(messages?.case?.id);
    commit(SET_CURRENT_ACTIVITY, messages);
    messages = messages && messages.messages;
    const customerType = undefined;
    messages = formattedMessages(orderBy(messages, 'insertedAt', 'desc'), customerType, currentID);
    commit('SAVE_ACTIVITY_MESSAGES', { activityId, messages });
    return messages;
  },
  async setCurrentActivity({ commit, dispatch }, activity) {
    const activityId = activity.id;
    commit(SET_CURRENT_ACTIVITY, activity);
    const messages = await dispatch('loadActivityMessages', { activityId });
    commit('SET_ACTIVITY_MESSAGES', { messages });
  },
  removeCurrentActivity({ commit }) {
    commit('RESET_CURRENT_ACTIVITY');
    commit('RESET_ACTIVITY_MESSAGES');
  },
  setShowClientCases({ commit }, value) {
    commit('SET_SHOW_CLIENT_CASES', value);
  },
  setShowClientCard({ commit }, value) {
    commit('SET_SHOW_CLIENT_CARD', value);
  },
};

const mutations = {
  SET_CLIENT(state, client) {
    state.client = client;
  },
  SET_OMNI_CUSTOMER(state, omniCustomer) {
    const client = { ...state.client, omniCustomer };
    state.client = client;
  },
  SET_CLIENT_CASES(state, cases) {
    state.clientCases = cases;
  },
  SET_CLIENT_OPENED_CASES(state, {
    clientOpenedCases, total, totalActivitiesCount, moreData, firstActivityDate,
  }) {
    if (moreData) {
      state.clientOpenedCases = state.clientOpenedCases.concat(clientOpenedCases);
    } else {
      state.clientOpenedCases = clientOpenedCases;
    }
    state.totalActivitiesCount = totalActivitiesCount || state.totalActivitiesCount;
    state.openedCasesTotal = total || state.openedCasesTotal;
    state.firstActivityDate = firstActivityDate || state.firstActivityDate;

    mutations.SET_STOP_FETCHING(state);
  },
  SET_CLIENT_CLOSED_CASES(state, {
    clientClosedCases, total, totalActivitiesCount, moreData, firstActivityDate,
  }) {
    if (moreData) {
      state.clientClosedCases = state.clientClosedCases.concat(clientClosedCases);
    } else {
      state.clientClosedCases = clientClosedCases;
    }
    state.totalActivitiesCount = totalActivitiesCount || state.totalActivitiesCount;
    state.closedCasesTotal = total || state.closedCasesTotal;
    state.firstClosedCasesActivityDate = firstActivityDate || state.firstClosedCasesActivityDate;

    mutations.SET_STOP_FETCHING(state);
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SET_CURRENT_ACTIVITY(state, activity) {
    state.team = activity.team;
    state.currentActivity = !isEmpty(state.currentActivity)
      && state.currentActivity.id.toString() === activity.id.toString() ? {
        ...state.currentActivity,
        ...activity,
      } : activity;
  },
  RESET_CURRENT_ACTIVITY(state) {
    state.currentActivity = undefined;
  },
  SAVE_ACTIVITY_MESSAGES(state, { activityId, messages }) {
    const index = findIndex(state.activitiesMessages, (x) => x.id === activityId);
    if (index === -1) {
      const activityMessages = { id: activityId, messages };
      state.activitiesMessages.push(activityMessages);
    }
  },
  SET_ACTIVITY_MESSAGES(state, { messages }) {
    state.activityMessages = messages;
  },
  RESET_ACTIVITY_MESSAGES(state) {
    state.activityMessages = [];
  },
  SET_SHOW_CLIENT_CASES(state, value) {
    state.showClientCases = value;
  },
  SET_SHOW_CLIENT_CARD(state, value) {
    state.showClientCard = value;
  },
};

const clientCardGetters = {
  omniCustomer(state) {
    return state.client.omniCustomer;
  },
  activityMessages(state) {
    return sortBy(state.activityMessages, (item) => item.id);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters: clientCardGetters,
};

export default store;
